import React from 'react'
import { useSelector } from 'react-redux'

import { Loader } from 'packages/common'

import { ApplicationState } from 'app/fieldapp/store/store'
import { getSortedTicketIdsForUser } from 'app/fieldapp/store/tickets/selectors'
import { User } from 'app/fieldapp/store/users'
import { useReloadAppData } from 'app/fieldapp/utils/hooks/useReloadAppData'

import { TicketsPage } from './TicketsPage'

export type TicketsPageContainerProps = {
  activeUser?: User
  lastFetch: number
}

export const TicketsPageContainer: React.FC<TicketsPageContainerProps> = ({
  activeUser,
  lastFetch,
}) => {
  const activeUserId = activeUser?.id || ''
  const ticketIds = useSelector((state: ApplicationState) =>
    getSortedTicketIdsForUser(state, activeUserId),
  )

  const { isLoading, onRefetchAppData } = useReloadAppData()

  if (isLoading) {
    return <Loader />
  }

  return (
    <TicketsPage
      lastFetch={lastFetch}
      onRefetch={onRefetchAppData}
      ticketIds={ticketIds}
    />
  )
}
